import api from "utils/api";

export const getPartnerSummary = (filters) => {
  return new Promise((resolve, reject) => {
    return api
      .get("/manager/summary/partners", { params: filters })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOverviewSummary = (filter) => {
  return new Promise((resolve, reject) => {
    return api
      .get("/admin/summary/commission?per_page=10&page=1", { params: filter })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSettlementSummary = () => {
  return new Promise((resolve, reject) => {
    return api
      .get("/partner/summary/settlements")
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateGiftVoucherDiscount = (id, data) => {
	return new Promise((resolve, reject) => {
		return api
			.put(`https://billpay.mtmpay.in/Admin/api/admin/gift-voucher-discount-update/${id}`, data)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const getTransactionSummary = () => {
  return new Promise((resolve, reject) => {
    return api
      .get("/partner/summary/transactions")
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOverviewadminSummary = (filter) => {
  return new Promise((resolve, reject) => {
    return api
      .get("/admin/summary/overview-admin", { params: filter })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getOverviewadminSummaryMerchant = () => {
  return new Promise((resolve, reject) => {
    return api
      .get("/admin/summary/overview-admin-merchant-list")
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// export const getOverviewadminSummaryPayin = (filters) => {
//   const token = localStorage.getItem("token");
//   return new Promise((resolve, reject) => {
//     return api
//       .post("/admin-dashboard", { params: filters }, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//       },
//       })
//       .then((response) => {
//         resolve(response.data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const getOverviewadminSummaryPayin = (payload) => {
  const token = localStorage.getItem("token");
  return new Promise((resolve, reject) => {
    return api
      .post("/admin-dashboard", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const payoutgetPartnerSummary = (filters) => {
  return new Promise((resolve, reject) => {
    return api
      .post("authentication-list", filters)
      .then((response) => {
        console.warn(response.data);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const giftvoucherlist = (filters) => {
  return new Promise((resolve, reject) => {
    return api
      .post("gift-voucher-list", filters)
      .then((response) => {
        console.warn(response.data);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const ComplaintList = (filters) => {
  return new Promise((resolve, reject) => {
    return api
      .post("users-complain-list", filters)
      .then((response) => {
        console.warn(response.data);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const payingetPartnerSummary = (filters) => {
  return new Promise((resolve, reject) => {
    return api
      .post("transaction-list", { params: filters })
      .then((response) => {
        console.warn(response.data);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
